module.exports = __webpack_public_path__ + "img/icon-cross.74c1b0c7.svg";